<template>
    <div class="p-12">
        <table v-if="mostrar == 'listado'" class="table table-report -mt-2">
            <thead>
                <tr>
                    <th class="w-2/12"><span class="w-64 inline-block">EMPRESA</span></th>
                    <th class="w-4/12" style="justify-content: start;">CENTROS</th>
                    <th class="w-3/12 text-center">ESTADO</th>
                    <th class="w-3/12 text-right">ACCIONES</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(empresa, index) in filterEmpresas" :key="index">
                    <td class="overflow-hidden w-2/12 pr-0">
                        <div>
                            {{empresa.nombre_de_la_empresa}}
                        </div>
                    </td>
                    <td class="w-4/12 flex-wrap pr-0">
                        <div class="w-full">
                            <div class="m-2" v-for="rel in centrosVisibles(empresa)">
                                {{rel.centro_bd[0].nombre_del_centro}} <span class="text-gray-500">(Emp: {{rel.lista_empleados.length}} - Subc: {{rel.lista_subcontratas.length}})</span>
                            </div>
                        </div>
                    </td>
                    <td class="w-3/12 pr-0">
                        <div class="text-center text-orange-400">
                            <div class="m-2" v-for="rel in centrosVisibles(empresa)">
                                <div v-if="botones == 'ultimos-docs'">{{rel.archivos_pendientes_revision}} archivos pendientes de revisar</div>
                                <template v-else>
                                    <div v-if="rel.archivos_pendientes_subir">{{rel.archivos_pendientes_subir}} archivos sin subir</div>
                                    <div v-if="rel.archivos_pendientes_revision">{{rel.archivos_pendientes_revision}} archivos pendientes de revisar</div>
                                    <div v-if="!rel.archivos_pendientes_subir && !rel.archivos_pendientes_revision">Todos los archivos subidos</div>
                                </template>
                            </div>
                        </div>
                    </td>
                    <td class="w-3/12 flex justify-center items-center">
                        <div class="flex justify-center items-center" v-if="botones == 'listado'">
                            <button class="m-2" @click="modificar(empresa)"><EditIcon class="w-3 h-3 mr-1 inline-block"/>Modificar</button>
                            <button class="m-2 text-red-600" @click="eliminar(empresa)">Eliminar <XSquareIcon class="w-3 h-3 mr-1 inline-block"/></button>
                        </div>
                        <div class="flex flex-col justify-center items-center" v-if="botones == 'resumen'">
                            <div v-for="rel in empresa.relacion_centros">
                                <button class="m-2" @click="verResumen(empresa, rel.centro_bd[0].num)"><EditIcon class="w-3 h-3 mr-1 inline-block"/>Ver resumen</button>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center items-center" v-if="botones == 'ultimos-docs'">
                            <div v-for="rel in centrosVisibles(empresa)">
                                <button class="m-2" @click="verUltimosDocs(empresa, rel.centro_bd[0].num)"><EditIcon class="w-3 h-3 mr-1 inline-block"/>Ver últimos documentos</button>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center items-center" v-if="botones == 'docs'">
                            <div v-for="rel in empresa.relacion_centros">
                                <button class="m-2" @click="verDocs(empresa, rel.centro_bd[0].num)"><EditIcon class="w-3 h-3 mr-1 inline-block"/>Ver documentos</button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="mostrar == 'resumen'">
            <Control :mostrar_resumen="true"></Control>
        </div>
        <div v-if="mostrar == 'ultimos-docs'">
            <Control :mostrar_resumen="true" :solo_pendientes_revision="true"></Control>
        </div>
        <div v-if="mostrar == 'docs'">
            <Control></Control>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    table,
    tbody,
    thead {
      display: block;/* whatever, just  reset table layout display to go further */
    }
    tr {
      display:flex;
      flex-wrap:wrap; /* allow to wrap on multiple rows */
      margin-top: .3rem;
    }
    td, th {
      display:flex;
      justify-content: center;
      align-items: center;
      /*flex:1 /* to evenly distributs flex elements */
    }
    td > div {
        width: 100%;
    }
    .break {
        width: 100%;
        flex: auto;
        padding: 0;
        margin-top: 8px;
        background: none !important;
    }
    .break > div { width: 100%; }
    tr.hide-childs {
        margin: 0;
    }
    tr.hide-childs > td:not(.break) {
        display: none;
    }
    .table-report > tbody > tr:not(.block) td {
        /*box-shadow: 10px 10px rgba(0,0,0,.5)*/
        /*box-shadow: 20px 3px 20px #0000000b;*/
    }
</style>
<script>
import Vue from "vue";
import Control from "@/views/Control";

export default {
    props: ["botones"],
    components: {
        Control
    },
    data() {
        return {
            mostrar: 'listado',
            empresas: [],
            centros: [],
            search_centro: '',
            search_empresa: ''
        }
    },
    watch:{
        $route (to, from){
            if(to.path == '/empresas-y-centros') {
                this.mostrar = 'listado';
                window.bus.$emit('hideFilter', false);
            }
            if(this.$d().user.centro && to.path == '/empresa-resumen') {
                this.mostrar = 'resumen';
                window.bus.$emit('hideFilter', true);
            }
            if(this.$d().user.centro && to.path == '/ultimos-docs') {
                this.mostrar = 'ultimos-docs';
                window.bus.$emit('hideFilter', true);
            }
            if(this.$d().user.centro && to.path == '/control-docs') {
                this.mostrar = 'docs';
                window.bus.$emit('hideFilter', true);
            }
        }
    },
    computed: {
        filterEmpresas() {
            let empresas = this.empresas;
            if(this.search_empresa) {
                empresas = empresas.filter(empresa => empresa.num == this.search_empresa)
            }
            if(this.search_centro) {
                empresas = empresas.filter(empresa => empresa.relacion_centros.find(centro => centro.centro_bd[0].num == this.search_centro))
            }
            if(this.botones == 'ultimos-docs') {
                empresas = empresas.filter(empresa => empresa.relacion_centros.some(rel => rel.archivos_pendientes_revision > 0));
            }
            return empresas;
        }
    },
    mounted() {
        window.bus.$on('visionGlobal', () => this.init(true));
        window.bus.$on('dataReloaded', () => this.init());
        window.bus.$on('filtrarCentro', (centro) => this.search_centro = centro.num);
        window.bus.$on('filtrarEmpresa', (empresa) => this.search_empresa = empresa.num);
        this.init();
        if(this.$d().user.centro && this.$router.history.current.path == '/empresa-resumen') {
            this.mostrar = 'resumen';
            window.bus.$emit('hideFilter', true);
        }
        if(this.$d().user.centro && this.$router.history.current.path == '/ultimos-docs') {
            this.mostrar = 'ultimos-docs';
            window.bus.$emit('hideFilter', true);
        }
        if(this.$d().user.centro && this.$router.history.current.path == '/control-docs') {
            this.mostrar = 'docs';
            window.bus.$emit('hideFilter', true);
        }
    },
    methods: {
        centrosVisibles(empresa) {
            if(this.botones == 'ultimos-docs') {
                return empresa.relacion_centros.filter(rel => rel.archivos_pendientes_revision > 0);
            }
            return empresa.relacion_centros;
        },
        init(returnToList = false) {
            if(returnToList) {
                this.mostrar = 'listado';
                window.bus.$emit('hideFilter', false);
            }
            this.empresas = this.$d().user.empresas;
            this.centros = this.$d().user.centros;
        },
        closeModal() {
            cash("#ok-confirmation-modal").modal("show");
        },
        modificar(empresa) {
            CmsApi.hook("/hooks/login/",{empresa: empresa.num},(data) => {
                if (data.success) {
                    this.$router.push('empresa');
                }
            });
        },
        verResumen(empresa, centro) {
            CmsApi.hook("/hooks/login/",{empresa: empresa.num ,centro: centro},(data) => {
                if (data.success) {
                    //this.$router.push('resumen');
                    window.bus.$emit('reloadDataFromServer');
                    window.bus.$emit('hideFilter', true);
                    this.mostrar = 'resumen';
                }
            });
        },
        verUltimosDocs(empresa, centro) {
            CmsApi.hook("/hooks/login/",{empresa: empresa.num ,centro: centro},(data) => {
                if (data.success) {
                    //this.$router.push('resumen');
                    window.bus.$emit('reloadDataFromServer');
                    window.bus.$emit('hideFilter', true);
                    this.mostrar = 'ultimos-docs';
                }
            });
        },
        verDocs(empresa, centro) {
            CmsApi.hook("/hooks/login/",{empresa: empresa.num ,centro: centro},(data) => {
                if (data.success) {
                    //this.$router.push('resumen');
                    window.bus.$emit('reloadDataFromServer');
                    window.bus.$emit('hideFilter', true);
                    this.mostrar = 'docs';
                }
            });
        },
        eliminar(empresa) {
            if(confirm('Con esta acción se va a eliminar la empresa y sus relaciones ¿Está seguro?')) {
                CmsApi.hook("/hooks/save/",{action: 'desactivar_empresa', data:JSON.stringify({empresa: empresa.num})},(data) => {
                    if (data.success) {
                        window.bus.$emit("reloadDataFromServer", data);
                    }
                });
            }
        }
    }
}
</script>